import { Component, inject } from '@angular/core';
import { NgFor } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { TranslationService } from '../../services/translation.service';
import { keycloakLogout } from '../../auth/keycloak.config';

type MenuItem = {
  labelKey: string;
  path: string;
};

@Component({
  selector: 'app-sidebar-menu',
  standalone: true,
  imports: [NgFor, RouterLink, RouterLinkActive, NzPopconfirmModule],
  templateUrl: './sidebar-menu.component.html'
})
export class SidebarMenuComponent {
  protected readonly i18n = inject(TranslationService);
  protected isCollapsed = false;
  protected readonly items: MenuItem[] = [
    { labelKey: 'sidebar.items.heatmap', path: '/heatmap' },
    { labelKey: 'sidebar.items.settings', path: '/settings' },
    { labelKey: 'sidebar.items.users', path: '/user-management' },
    { labelKey: 'sidebar.items.licenses', path: '/license-management' },
    { labelKey: 'sidebar.items.antennas', path: '/antenna-management' },
    { labelKey: 'sidebar.items.bomComponents', path: '/bom-component-management' },
    { labelKey: 'sidebar.items.obstacles', path: '/obstacle-management' },
    { labelKey: 'sidebar.items.ipd', path: '/ipd-management' },
    { labelKey: 'sidebar.items.channels', path: '/channel-management' },
    { labelKey: 'sidebar.items.amplifiers', path: '/amplifier-management' },
    { labelKey: 'sidebar.items.floorplans', path: '/floorplan-management' },
    { labelKey: 'sidebar.items.projects', path: '/project-management' }

  ];

  protected labelFor(item: MenuItem): string {
    return this.i18n.translate(item.labelKey);
  }

  protected toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  protected logout(): void {
    keycloakLogout({ redirectUri: window.location.origin });
  }
}
